import { render, staticRenderFns } from "./ProviderNotifications.vue?vue&type=template&id=ca87450e&"
import script from "./ProviderNotifications.vue?vue&type=script&lang=js&"
export * from "./ProviderNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports